import { appMethod as app, appInstance } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GpMyOrder.less';

export default class GpMyOrder extends OfficialPage {
  state = {
    haveData: true,
    goodsList: [],
    isLeader: true,
    sub_shop_app_id: '',
    type: 0,
    formid: [],
    shareInfo: {
      group_price: '',
      share_cover: '',
      share_title: ''
    }
  }
  page = 1
  isMore = 1

  constructor(props) {
    super(props);
    document.title = '我的拼团';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      franchiseeId: options.franchisee || ''
    })
    this.pageInit()
  }

  pageInit = () => {
    var _this = this
    if (app.isLogin()) {
      _this.loadAll()
    } else {
      app.goLogin({
        success: function () {
          _this.loadAll()
        }
      })
    }
  }
  loadAll = () => {
    var _this = this
    _this.loadMyTeams()
  }
  loadMyTeams = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/myTeams',
      data: {
        page: _this.page,
        status: _this.data.type,
        is_leader: _this.data.isLeader ? '1' : '0',
        page_size: 10,
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      success: res => {
        if (_this.isMore === 0) {
          return
        }
        var expired = '',
          nowdate = '',
          goodsList = _this.data.goodsList.concat(res.data)
        for (var index in goodsList) {
          ; (goodsList[index].index = index), (nowdate = res.current_time * 1000)
          expired = _this.countTime(
            goodsList[index].expired_time * 1000 - nowdate
          )
          goodsList[index].expired =
            '(距结束约' +
            (expired[0] != '00'
              ? expired[0] + '天'
              : expired[1] != '00'
                ? expired[1] + '小时'
                : expired[2] != '00'
                  ? expired[2] + '分'
                  : expired[3] != '00'
                    ? '1分'
                    : '') +
            ')'
        }
        _this.setData({
          goodsList: goodsList,
          haveData: goodsList.length > 0 ? true : false
        })
        _this.page++
        _this.isMore = res.is_more
      }
    })
  }
  goToGroupDetail = e => {
    let franchisee = e.currentTarget.dataset.subid
    let chainParam = franchisee ? '&franchisee=' + franchisee : ''
    var data = e.currentTarget.dataset,
      pageUrl =
        '/group/pages/gporderDetail/gporderDetail?from=myOrder' +
        '&teamtoken=' +
        data.teamtoken +
        chainParam
    this.saveUserFormId(function () {
      app.turnToPage(pageUrl)
    })
  }
  inviteFriends = e => {
    let that = this
    var data = e.currentTarget.dataset
    var franchisee = data.subid
    let indexTeams = e.currentTarget.dataset.index
    let myTeams = this.data.goodsList[indexTeams]
    let goodsInfo = myTeams.goods_info[0]
    let goods_id = myTeams.goods_id
    let activity_id = myTeams.activity_id
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/GetGoodsShareInfo',
      data: {
        goods_id: goods_id,
        activity_id: activity_id,
        sub_shop_app_id: franchisee || ''
      },
      success: function (res) {
        var data = {}
        data['shareInfo.group_price'] = res.data.price
        data['shareInfo.share_cover'] = res.data.share_cover
        data['shareInfo.share_title'] = res.data.share_title
        that.setData(data)
        app.sendRequest({
          url: '/index.php?r=appGroupBuy/getShareQRCode',
          data: {
            goods_id: goods_id,
            activity_id: activity_id,
            sub_shop_app_id: franchisee || '',
            type: 6,
            text: goodsInfo.goods_name,
            price: goodsInfo.price,
            virtual_price:
              goodsInfo.virtual_price == '0.00'
                ? goodsInfo.original_price
                : goodsInfo.virtual_price,
            goods_img: goodsInfo.cover,
            user_token: app.globalData.PromotionUserToken || '',
            team_token: myTeams.team_token,
            order_id: myTeams.order_id
          },
          success: function (res) {
            // animation.bottom('0').step()
            // that.setData({
            //   'pageQRCodeData.shareDialogShow': 0,
            //   'pageQRCodeData.shareMenuShow': true,
            //   'pageQRCodeData.goodsInfo': res.data,
            //   'pageQRCodeData.animation': animation.export(),
            //   goodsShareData: myTeams
            // })
            appInstance.pageQrcodeRef.current.show({
              pageQRCodeData: {
                'shareDialogShow': 0,
                'shareMenuShow': true,
                'goodsInfo': res.data,
              },
            });
            that.setData({
              goodsShareData: myTeams
            })
          }
        })
      }
    })
  }
  changeIdentity = e => {
    var data = e.currentTarget.dataset
    this.setData({
      isLeader: data.isleader == 'true' ? true : false,
      type: 0,
      goodsList: []
    })
    this.page = 1
    this.isMore = 1
    this.loadMyTeams()
  }
  changeType = e => {
    var data = e.currentTarget.dataset
    this.setData({
      type: data.type,
      goodsList: []
    })
    this.page = 1
    this.isMore = 1
    this.loadMyTeams()
  }
  openNewGroup = e => {
    var data = e.currentTarget.dataset
    var franchisee = data.subid === app.getAppId() ? '' : data.subid
    var chainParam = franchisee ? '&franchisee=' + franchisee : ''
    var pathUrl =
      '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
      data.goodsid +
      '&activity_id=' +
      data.activityid +
      chainParam
    if ((data.status == 3 && data.type == 4) || data.groupbuy == 0) {
      app.turnToPage(
        '/pages/goodsDetail/goodsDetail?detail=' + data.goodsid + chainParam
      )
      return
    }
    if (data.status == '5') {
      app.showModal({
        content: '该拼团活动已结束'
      })
      return
    }
    this.saveUserFormId(function () {
      app.turnToPage(pathUrl)
    })
  }
  gotoGoodsOrder = e => {
    let franchisee = e.currentTarget.dataset.subid
    let chainParam = franchisee ? '&franchisee=' + franchisee : ''
    var pathUrl =
      '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' +
      e.currentTarget.dataset.orderid +
      chainParam
    this.saveUserFormId(function () {
      app.turnToPage(pathUrl)
    })
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        form_id: _this.data.formid || [],
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      complete: function () {
        app.hideLoading()
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }
  countTime = difference => {
    if (difference < 0) {
      return ['00', '00', '00']
    }
    let _second = 1000,
      _minute = _second * 60,
      _hour = _minute * 60,
      _date = _hour * 24,
      time = []
    let dates = Math.floor(difference / _date),
      hours = Math.floor((difference % _date) / _hour),
      minutes = Math.floor((difference % _hour) / _minute),
      seconds = Math.floor((difference % _minute) / _second)
    dates = String(dates).length >= 2 ? dates : +dates
    hours = String(hours).length >= 2 ? hours : '0' + hours
    minutes = String(minutes).length >= 2 ? minutes : '0' + minutes
    seconds = String(seconds).length >= 2 ? seconds : '0' + seconds
    time[0] = dates
    time[1] = hours
    time[2] = minutes
    time[3] = seconds
    return time
  }

  componentDidMount() { }

  componentDidShow() { }

  componentDidHide() { }

  componentWillUnmount() { }

  onPullDownRefresh = () => { }
  onReachBottom = () => {
    if (this.isMore) {
      this.loadAll()
    }
  }
  onShareAppMessage = e => {
    var that = this,
      myTeams = this.data.goodsShareData,
      goodsInfo = myTeams.goods_info[0],
      shareInfo = this.data.shareInfo,
      team_token = myTeams.team_token,
      type = myTeams.activity_type,
      urlPromotion = app.globalData.PromotionUserToken
        ? '&user_token=' + app.globalData.PromotionUserToken
        : '',
      url = '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' + team_token,
      nickname = app.getUserInfo('nickname'),
      share_cover = shareInfo.share_cover
        ? shareInfo.share_cover
        : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
      title = shareInfo.share_title
        ? shareInfo.share_title
        : (nickname ? nickname + ' 喊你' : '') +
        '拼单啦~ ' +
        shareInfo.group_price +
        '元拼' +
        goodsInfo.goods_name +
        '，火爆抢购中......'
    return app.shareAppMessage({
      title: title,
      path: url,
      imageUrl: share_cover,
      success: function (addTime) {
        app.showToast({
          title: '转发成功',
          duration: 500
        })
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: {
            add_time: addTime,
            sub_shop_app_id: that.data.franchiseeId || ''
          },
          success: function (res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      pageQRCodeData,
      isLeader,
      goodsInfo,
      type,
      goodsList,
      haveData
    } = this.state
    return (
      <div className="official-page gp-my-order">
        <TopNav title="我的拼团" />
        <React.Fragment>
          <div className="collage-myOrder">
            <div className="collage-section collage-classify">
              <div className="total-classify">
                <div
                  className={(isLeader ? 'active' : '') + '  isRelative'}
                  onClick={this.changeIdentity}
                  data-isleader="true"
                >
                  我发起的团
                </div>
                <div
                  className={(!isLeader ? 'active' : '') + ' isRelative'}
                  onClick={this.changeIdentity}
                  data-isleader="false"
                >
                  我参与的团
                </div>
              </div>
              <ScrollView className="branch-classify" scroll-x="true">
                <div
                  className={(type == '0' ? 'active' : '') + ' isRelative'}
                  onClick={this.changeType}
                  data-type="0"
                >
                  全部
                </div>
                <div
                  className={(type == '2' ? 'active' : '') + ' isRelative'}
                  onClick={this.changeType}
                  data-type="2"
                >
                  拼团中
                </div>
                <div
                  className={(type == '3' ? 'active' : '') + ' isRelative'}
                  onClick={this.changeType}
                  data-type="3"
                >
                  拼团成功
                </div>
                <div
                  className={(type == '4' ? 'active' : '') + ' isRelative'}
                  onClick={this.changeType}
                  data-type="4"
                >
                  拼团结束
                </div>
                {isLeader && (
                  <div
                    className={(type == '5' ? 'active' : '') + ' isRelative'}
                    onClick={this.changeType}
                    data-type="5"
                  >
                    已关闭
                  </div>
                )}
              </ScrollView>
            </div>
            <div className="collage-section collage-content">
              {haveData ? (
                <React.Fragment>
                  <div className="data-list">
                    {goodsList.map((item, index) => {
                      return (
                        <div
                          className="data-item  isRelative"
                          key={index}
                          onClick={this.goToGroupDetail}
                          data-teamtoken={item.team_token}
                        >
                          <div className="state-wrap">
                            <div className="timetable">{item.add_time}</div>
                            <div
                              className="status"
                              style={convertLineStyleData(
                                'color: ' +
                                (item.current_status_title != '拼团中'
                                  ? '#666'
                                  : '#ff7100')
                              )}
                            >
                              {item.current_status_title +
                                (item.current_status == 2 ? item.expired : '')}
                            </div>
                          </div>
                          {item.parent_shop_app_id && (
                            <div className="sub_name">
                              {'店铺：' + item.app_name}
                            </div>
                          )}
                          <div className="infor-wrap">
                            <div className="image-wrap">
                              <img src={item.goods_info[0].cover} />
                            </div>
                            <div className="detail-wrap">
                              <div className="title">
                                {item.goods_info[0].goods_name}
                              </div>
                              <div className="buy-infor">
                                <div className="price">
                                  <span>
                                    {(item.activity_type == 0
                                      ? item.max_user_num + '人团'
                                      : item.activity_type == 1
                                        ? '新人团'
                                        : item.activity_type == 2
                                          ? '阶梯团'
                                          : item.activity_type == 3
                                            ? '帮帮团'
                                            : '抽奖团') +
                                      ' ' +
                                      (item.data ? item.data.type : '') +
                                      ' ¥'}
                                  </span>
                                  <span>{item.goods_info[0].price}</span>
                                </div>
                                <div className="num">
                                  {'x' + item.goods_info[0].num}
                                </div>
                              </div>
                              <div className="btn-wrap">
                                {item.current_status == 1 ? (
                                  <React.Fragment>
                                    <div className="buy-now orange">
                                      立即支付
                                    </div>
                                    <div className="not-spelling empty">
                                      不拼了
                                    </div>
                                  </React.Fragment>
                                ) : item.current_status == 2 ? (
                                  <React.Fragment>
                                    <div
                                      className="invite-friends orange"
                                      onClick={(e) => {this.inviteFriends(e);e.stopPropagation()}}
                                      data-index={item.index}
                                      data-subid={item.app_id}
                                    >
                                      邀请好友
                                    </div>
                                  </React.Fragment>
                                ) : item.current_status == 3 ? (
                                  <React.Fragment>
                                    <div
                                      className="spell-again orange"
                                      onClick={(e) => {this.openNewGroup(e);e.stopPropagation()}}
                                      data-goodsid={item.goods_id}
                                      data-activityid={item.activity_id}
                                      data-status={item.current_status}
                                      data-type={item.activity_type}
                                      data-groupbuy={item.is_group_buy}
                                      data-subid={item.app_id}
                                    >
                                      再拼一次
                                    </div>
                                    {item.order_status != 7 && (
                                      <div
                                        className="order-progress empty"
                                        onClick={(e) => {this.gotoGoodsOrder(e);e.stopPropagation()}}
                                        data-teamtoken={item.team_token}
                                        data-orderid={item.order_id}
                                        data-subid={item.app_id}
                                      >
                                        订单进度
                                      </div>
                                    )}
                                  </React.Fragment>
                                ) : (
                                        item.current_status == 4 && (
                                          <React.Fragment>
                                            <div
                                              className="spell-again orange"
                                              onClick={(e) => {this.openNewGroup(e);e.stopPropagation()}}
                                              data-goodsid={item.goods_id}
                                              data-activityid={item.activity_id}
                                              data-status={item.current_status}
                                              data-groupbuy={item.is_group_buy}
                                              data-subid={item.app_id}
                                            >
                                              再拼一次
                                      </div>
                                          </React.Fragment>
                                        )
                                      )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div className="no-more">暂无更多拼购</div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <div className="no-collage">
                      <div className="image-wrap">
                        <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/no-collage.png" />
                      </div>
                      <div className="tip-wrap">暂无拼团</div>
                    </div>
                  </React.Fragment>
                )}
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/gp-my-order/GpMyOrder.jsx